import * as React from "react";
import PageGenericError from "@mnemonic/mui5/PageGenericError";
import { DEFAULT_ERROR_KEY, ErrorBoundary } from "./ErrorBoundary";
const TopLevelErrorBoundary = ({ children, ...rest }) => (<ErrorBoundary {...rest} handlers={{
        [DEFAULT_ERROR_KEY]: { Component: PageGenericError },
    }}>
    {children}
  </ErrorBoundary>);
export default TopLevelErrorBoundary;
